import { useCallback } from 'react'

import { stopPropagation } from '../../../../../../utils/events'
import {
  toEmailRecipientFieldSelectItemsFromOption,
  withAdditionalContactRecipients,
} from '../../../EmailRecipientsField.utils'
import { EmailRecipientsFilterModal } from '../../../EmailRecipientsFilterModal'

export function useEmailRecipientsSelectActions({
  autoAddEnabled,
  closeSelect,
  filterModalInitialValues,
  updateValue,
  onClickBcc,
  onClickCc,
  onCloseModal,
  onOpenFilterModal,
  onSetMassMailing,
  onSetModal,
}) {
  const handleClickCc = useCallback(
    event => {
      stopPropagation(event)
      onClickCc?.()
    },
    [onClickCc]
  )

  const handleClickBcc = useCallback(
    event => {
      stopPropagation(event)
      onClickBcc?.()
    },
    [onClickBcc]
  )

  const handleChange = useCallback(
    items => {
      const baseRecipients = toEmailRecipientFieldSelectItemsFromOption(items)

      updateValue(
        autoAddEnabled
          ? withAdditionalContactRecipients(baseRecipients)
          : baseRecipients
      )
    },
    [autoAddEnabled, updateValue]
  )

  const handleOpenFilterModal = useCallback(
    event => {
      stopPropagation(event)
      closeSelect()

      if (onOpenFilterModal) {
        onOpenFilterModal(event, { updateValue, onCloseModal, onSetModal })
      } else {
        onSetModal?.(
          <EmailRecipientsFilterModal
            autoAddEnabled={autoAddEnabled}
            initialValues={filterModalInitialValues}
            onChange={handleChange}
            onClose={onCloseModal}
            onSetMassMailing={onSetMassMailing}
          />
        )
      }
    },
    [
      autoAddEnabled,
      closeSelect,
      filterModalInitialValues,
      handleChange,
      onCloseModal,
      onOpenFilterModal,
      onSetMassMailing,
      onSetModal,
      updateValue,
    ]
  )

  return { handleClickBcc, handleClickCc, handleOpenFilterModal }
}
